var path = '/templates/zenclerk_s/sites/setup/setup.html';
var html = "<div class=site-setup><div class=\"navbar-fixed-top steps\" ng-class=\"{'mr-margin': !vm.ZcsOemService.get()}\"><div class=col-md-1><a class=\"btn btn-close\" ui-sref=zenclerkS.project.dashboard(vm.project) master-only></a></div><ul class=\"step-selector col-md-10\"><li ng-repeat=\"state in vm.states\" ng-class=\"{'active': vm.isActiveState(state), 'before-active': vm.isPreviousState(state), 'disabled': vm.isDisabledState(state)}\" ng-click=vm.goToState(state)>{{state.label}}</li></ul></div><div class=ui-view-site-setup-view ui-view name=siteSetupView></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup.html
// module id = 1432
// module chunks = 0